import { createRoute, Outlet, redirect } from '@tanstack/react-router'
import { managementLayoutRoute } from '@/ui/pages/management'
import { useAuthStore } from '@/application/stores/auth.store'

export const investigationsRoute = createRoute({
  getParentRoute: () => managementLayoutRoute,
  path: 'investigations',
  beforeLoad: () => {
    const { user } = useAuthStore.getState()
    const canAccess = user?.role === 'streamer' || user?.role === 'admin'
    if (!canAccess) throw redirect({ to: '/manage/profile' })
  },
  component: InvestigationsLayout,
})

export function InvestigationsLayout() {
  return <Outlet />
}
